/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ watts: NonNullable<unknown> }} Ui_Laps_Efforts_WattsInputs */

const en_ui_laps_efforts_watts = /** @type {(inputs: Ui_Laps_Efforts_WattsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.watts} W`)
};

const de_ui_laps_efforts_watts = /** @type {(inputs: Ui_Laps_Efforts_WattsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.watts} W`)
};

/**
* | output |
* | --- |
* | "{watts} W" |
*
* @param {Ui_Laps_Efforts_WattsInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_laps_efforts_watts = /** @type {((inputs: Ui_Laps_Efforts_WattsInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Laps_Efforts_WattsInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_laps_efforts_watts(inputs)
	return de_ui_laps_efforts_watts(inputs)
});